// extracted by mini-css-extract-plugin
export default {"certificateCard":"certifications_certificateCard__OXwHy"};